document.addEventListener('DOMContentLoaded', () => {
  const products = document.querySelectorAll('.product-listing__link');
  const tabsContainer = document.querySelector('#filter-tabs');
  const collectionDropdown = document.querySelector('#filter-dropdown');
  const skinDropdown = document.querySelector('#skin-dropdown');

  // Uncomment when skin Dropdown is re-added
  if (!products.length || !tabsContainer || !collectionDropdown /*|| !skinDropdown */) return;

  // Hard-coded full collection list
  const collections = [
    'All Skin',
    'Balanced',
    'Melanin-Rich',
    'Sensitive',
  ];

  // Pull skin concerns from products dynamically
  const allSkin = new Set();
  products.forEach(product => {
    if (product.dataset.skin) {
      product.dataset.skin.split(',').forEach(s => allSkin.add(s.trim()));
    }
  });

  const makeSlug = name => name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');

  function buildCollections() {
    tabsContainer.innerHTML = '';
    collectionDropdown.innerHTML = '';

    const pathParts = window.location.pathname.split('/');
    const currentSlug = pathParts[pathParts.indexOf('collections') + 1] || 'all-skin';

    collections.forEach(coll => {
      const slug = makeSlug(coll);

      const link = document.createElement('a');
      link.textContent = coll;
      link.href = `/collections/${slug}`;
      link.classList.add('collection-tab');

      if (slug === currentSlug) {
        link.classList.add('active');
        link.setAttribute('aria-current', 'page');
        link.style.pointerEvents = 'none';
      }
      tabsContainer.appendChild(link);

      const option = document.createElement('option');
      option.value = `/collections/${slug}`;
      option.textContent = coll;

      if (slug === currentSlug) {
        option.selected = true;
        option.disabled = true;
      }
      collectionDropdown.appendChild(option);
    });
  }

  // buildSkinDropdown(); // ❌ REMOVE OR COMMENT THIS OUT

  function attachListeners() {
    collectionDropdown.addEventListener('change', e => {
      window.location.href = e.target.value;
    });

    // Only attach skin dropdown listener if the element exists
    if (skinDropdown) {
      skinDropdown.addEventListener('change', () => {
        const activeSkin = skinDropdown.value.trim();
        products.forEach(product => {
          const productSkin = product.dataset.skin
            ? product.dataset.skin.split(',').map(s => s.trim())
            : [];
          const productCard = product.closest('.product-listing__item');

          if (productCard) {
            productCard.style.display =
              activeSkin === 'All Skin' || productSkin.includes(activeSkin)
                ? ''
                : 'none';
          }
        });
      });
    }
  }

  buildCollections();
  attachListeners();
});
